import type { EnumType } from "@pdfking/structs"
import { NumberQ, RecordQ, StringQ } from "@pdfking/structs"

import type { AnyError } from "#public"
import type { Result } from "#public"

export function Failure<Name extends string | number>(name: Name): Result<never, EnumType<Name>>
export function Failure<Name extends string | number, T extends Record<string, unknown>>(
  name: Name,
  context: T
): Result<never, EnumType<Name, T>>
export function Failure<E extends AnyError>(error: E): Result<never, E>
export function Failure(error: unknown): Result<never>
export function Failure(input: unknown, context?: Record<string, unknown>): Result<never> {
  let error: AnyError
  if (StringQ(input) || NumberQ(input)) {
    error = { enum: input } as AnyError
  } else if (RecordQ(input) && (StringQ(input.enum) || NumberQ(input.enum))) {
    error = input as AnyError
  } else {
    error = { enum: "INTERNAL_ERROR", error: input }
  }
  // oxlint-disable-next-line pdfking/prefer-record-merge-dependency -- @pdfking/tfunc depends on this package
  if (context) error = { ...error, ...context } as AnyError
  return { value: undefined, error }
}
